<script lang="ts">
    import { Divider, TextButton } from '@allibee/components';
    import { ModalTermRevisionsPreview } from '$lib/service';
    import Constants from '$lib/constants';

    import { MtmService } from '$lib/api';
    import { custom } from '$lib/utils';
    import { _ } from 'svelte-i18n';
    import { twMerge } from 'tailwind-merge';
    import { onMount } from 'svelte';

    let terms: MtmTermSimpleDto[] | undefined = undefined;
    let loading = true;

    onMount(async () => {
        try {
            const res = await MtmService.listTermsActiveAndEffective({ type: 'SERVICE' });
            terms = res.data.data;
        } finally {
            loading = false;
        }
    });
</script>

<footer class={twMerge('flex w-full items-center justify-center', $$props.class)}>
    <div class="font-regular flex items-center space-x-2">
        {#if !loading && terms}
            {#each terms as term}
                {#if Constants.TERMS_PRIVACY_POLICY_TITLES.includes(term.title)}
                    <TextButton
                        class={`justify-start whitespace-pre-wrap text-pretty text-start text-sm font-normal text-gray-500`}
                        on:click={() => custom(ModalTermRevisionsPreview, { term }, { size: 'lg', maxHeight: '80vh' })}
                    >
                        {term.title}
                    </TextButton>
                {/if}
            {/each}
            <Divider direction="vertical" class="h-5 bg-gray-200" />
            <TextButton href="https://guide.allibee.ai/" target="_blank" class="text-sm font-normal text-gray-500">{$_('apps.contract.lib.service.helpDesk.FooterHelpDesk.userGuide')}</TextButton>
            <Divider direction="vertical" class="h-5 bg-gray-200" />
            <TextButton href="https://8kln6.channel.io/" target="_blank" class="text-sm font-normal text-gray-500">
                {$_('apps.contract.lib.service.helpDesk.FooterHelpDesk.customerCenter')}
            </TextButton>
        {/if}
    </div>
</footer>
